import React from "react";
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";
import { Grid } from "@material-ui/core";
import "./inputHL.css";
import { useState } from "react";
import LabelErrorPure from "../labelErrorPure/labelErrorPure";

const InputHLPure = (props) => {
  const {
    labelInput, //Label text from input
    autoFocus, //Set focus in the input
    typeInput, //Type input (text, email, number, etc.)
    valueInput, //If it has a predefined value or a start value
    // validateInput,
    setSpace,
    handleChangeInput, //Function onChange for value change
    characterLimit, // Text input character limit
    required,
    disabled, //disabled input
    extraContent,
    errorInput, //Error true or false
    errorInputText, //Error text to validate input
    tooltipShow, //True or false to show tooltip
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    titleTooltip, //Title tooltip string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description optional
    restContent, //More text to tooltip description optional
    informationIcon, // Choose the information icon true or false to custom img
    inputActive, //True to active input with underline, false to send text
    readOnlyText, //send text if you dont use input
    onBlur, //function blur input
    styleGrid,
    styleInput,
    inputTypeBox // true or false if input type box or fals if input has an underline
  } = props;

  //Function, hooks, you can use this to extract the value of the input wherever you are going to use it
  // const [inputValue, setInputValue] = useState(valueInput || "");
  // const [errorInput, setErrorInput] = useState(false);

  // const handleChange = (event) => {
  //   if (event.target.value === undefined || event.target.value === "") {
  //     setErrorInput(true);
  //   } else {
  //     setInputValue(event.target.value);
  //   }
  // };

  const [chars, setChars] = useState(0);

  const onLimitedTextChange = (event) => {
    setChars(event.target.value.length);
    handleChangeInput(event);
  }

  return (
    <Grid
      item
      xs={12}
      lg={12}
      md={12}
      sm={12}
      className="inputHLPure-container"
      style={styleGrid}
    >
      <div className="inputHLPure-container-text"
        style={setSpace ? { justifyContent: "space-between" } : null}
      >
        {labelInput &&
          <label className="inputHLPure-label" name="label">
            {labelInput}{required && " *"}
          </label>}

        {tooltipShow ? (
          <TooltipHLPure
            positionTooltip={positionTooltip}
            titleTooltip={titleTooltip}
            descriptionTooltip={descriptionTooltip}
            subContent={subContent}
            restContent={restContent}
            informationIcon={informationIcon}
          />
        ) : (
          ""
        )}
        {extraContent}
      </div>
      {inputActive ? (
        <input
          {...props}
          autoFocus={autoFocus}
          type={typeInput}
          required={required}
          className={inputTypeBox ? "inputHLPure-input-type-box" : "inputHLPure-input"}
          name="inputValue"
          value={valueInput || ""}
          onChange={typeInput == "text" && characterLimit ? onLimitedTextChange : handleChangeInput}
          onBlur={onBlur}
          onWheel={typeInput == "number" ? (e) => e.target.blur() : null}
          // component={validateInput}
          disabled={disabled}
          style={styleInput}
          maxLength={characterLimit}
        />
      ) : (
        <p className="inputHLPure-readOnlyText">{readOnlyText}</p>
      )}
      <div className="inputHLPure-hints">
        {errorInput && (
          <LabelErrorPure label={errorInputText}/>
        )}
        {typeInput == "text" && characterLimit && (
          <span className="character-limit">{chars}/{characterLimit}</span>
        )}
      </div>
    </Grid>
  );
};

export { InputHLPure as default };
